// Search by Panel
// - Query Storefront API by brand (vendor), filter by panel metafield, calculate quantities
(function () {
    'use strict';

    // ---------------------------
    // Brand / Analyzer configuration
    // - analyzers: matched against "compatible_analyzers" metafield and shown in the button tooltip
    // - legacyAnalyzers: old generic names still present on products that weren't enriched yet (matched, not shown)
    // ---------------------------
    var BRAND_CONFIG = {
        'abbott-architect':   { brand: 'Abbott',          analyzers: ['ARCHITECT c', 'ARCHITECT i'] },
        'abbott-alinity':     { brand: 'Abbott',          analyzers: ['Abbott Alinity ci', 'Abbott Alinity i'] },
        'beckman-au-dxc':     { brand: 'Beckman Coulter',
                                analyzers: ['AU480', 'AU680', 'AU5800', 'AU400/AU640', 'AU2700/AU5400', 'DxC 500 AU', 'DxC 700 AU'],
                                legacyAnalyzers: ['AU Series', 'Dxc Series'] },
        'beckman-access-dxi': { brand: 'Beckman Coulter',
                                analyzers: ['Access 2', 'UniCel DxI 600/800', 'DxI 9000'],
                                legacyAnalyzers: ['Access', 'Dxl Series'] },
        'siemens-atellica':   { brand: 'Siemens',         analyzers: ['Atellica CH', 'Atellica IM'] }
    };

    // ---------------------------
    // Config (reuse global tokens set in theme.liquid)
    // ---------------------------
    var shopDomain = '';
    var storefrontToken = '';
    var apiVersion = '2025-10';
    var storefrontEndpoint = '';

    function buildStorefrontEndpoint() {
        if (!shopDomain || !apiVersion) return '';
        return 'https://' + shopDomain + '/api/' + apiVersion + '/graphql.json';
    }

    function getMeta(name) {
        var el = document.querySelector('meta[name="' + name + '"]');
        return el ? (el.content || '') : '';
    }

    // ---------------------------
    // DOM refs
    // ---------------------------
    var searchBtn, panelNameInput, panelCountInput;
    var resultsCard, resultsBody, addToCartBtn;
    var statusEl, cartStatusEl;

    // ---------------------------
    // Helpers
    // ---------------------------
    function debounce(fn, delay) {
        var t;
        return function () {
            var args = arguments;
            clearTimeout(t);
            t = setTimeout(function () { fn.apply(null, args); }, delay || 250);
        };
    }

    function getSelectedConfig() {
        var el = document.querySelector('input[name="sbp-brand"]:checked');
        if (!el) return null;
        return BRAND_CONFIG[el.value] || null;
    }

    function getMatchAnalyzers(config) {
        return config.analyzers.concat(config.legacyAnalyzers || []);
    }

    function getAnalyzersLabel(config) {
        return 'Includes: ' + config.analyzers.join(', ');
    }

    function getSelectedProductType() {
        var el = document.querySelector('input[name="sbp-product-type"]:checked');
        return el ? el.value : 'all';
    }

    function matchesProductType(product, productTypeFilter) {
        if (productTypeFilter === 'all') return true;
        var catType = (product.catalogType && product.catalogType.value) ? product.catalogType.value.trim().toLowerCase() : '';
        if (productTypeFilter === 'reagents') {
            return catType === 'reagent';
        }
        // "others" = everything that is NOT "reagent"
        return catType !== 'reagent';
    }

    function parseListMetafield(metafieldValue) {
        if (!metafieldValue) return [];

        try {
            var parsed = JSON.parse(metafieldValue);

            if (Array.isArray(parsed)) {
                return parsed
                    .map(function (s) { return String(s).trim(); })
                    .filter(Boolean);
            }

            if (typeof parsed === 'string') {
                return [parsed.trim()];
            }
        } catch (e) {
            // fallback below
        }

        return String(metafieldValue)
            .split(',')
            .map(function (s) { return String(s).trim(); })
            .filter(Boolean);
    }

    function matchesAnalyzer(product, requiredAnalyzers) {
        if (!requiredAnalyzers || !requiredAnalyzers.length) return true;

        var productAnalyzers = parseListMetafield(
            product.compatibleAnalyzers && product.compatibleAnalyzers.value
                ? product.compatibleAnalyzers.value
                : ''
        );

        if (!productAnalyzers.length) return false;

        var normalizedRequired = requiredAnalyzers.map(function (a) {
            return String(a).trim().toLowerCase();
        });

        for (var i = 0; i < productAnalyzers.length; i++) {
            var current = String(productAnalyzers[i]).trim().toLowerCase();
            if (normalizedRequired.indexOf(current) !== -1) {
                return true;
            }
        }

        return false;
    }

    // ---------------------------
    // State
    // ---------------------------
    var currentResults = []; // { sku, title, variantId (numeric), quantity }
    var tagCache = {};       // { 'Abbott': ['tag1','tag2',...], ... }
    var tagCachePromises = {}; // { 'Abbott': Promise } in-flight fetch promises

    // ---------------------------
    // Storefront API queries
    // ---------------------------
    var PRODUCTS_QUERY =
        'query SearchByPanel($q: String!, $after: String) {' +
        '  products(first: 250, query: $q, after: $after) {' +
        '    pageInfo { hasNextPage endCursor }' +
        '    edges {' +
        '      node {' +
        '        title' +
        '        handle' +
        '        tags' +
        '        variants(first: 100) {' +
        '          edges {' +
        '            node {' +
        '              id' +
        '              sku' +
        '              price { amount currencyCode }' +
        '            }' +
        '          }' +
        '        }' +
        '        commonPanels: metafield(namespace: "specs", key: "common_panels") { value }' +
        '        numberOfTests: metafield(namespace: "specs", key: "number_of_tests") { value }' +
        '        cptCodes: metafield(namespace: "specs", key: "cpt_codes") { value }' +
        '        rate: metafield(namespace: "specs", key: "rate") { value }' +
        '        testName: metafield(namespace: "specs", key: "test") { value }' +
        '        catalogType: metafield(namespace: "catalog", key: "type") { value }' +
        '        compatibleAnalyzers: metafield(namespace: "specs", key: "compatible_analyzers") { value }' +
        '      }' +
        '    }' +
        '  }' +
        '}';

    var PANELS_QUERY =
        'query PanelsByBrand($q: String!, $after: String) {' +
        '  products(first: 250, query: $q, after: $after) {' +
        '    pageInfo { hasNextPage endCursor }' +
        '    edges {' +
        '      node {' +
        '        commonPanels: metafield(namespace: "specs", key: "common_panels") { value }' +
        '        catalogType: metafield(namespace: "catalog", key: "type") { value }' +
        '      }' +
        '    }' +
        '  }' +
        '}';

    async function storefrontRequest(query, variables) {
        var res = await fetch(storefrontEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontToken
            },
            body: JSON.stringify({ query: query, variables: variables })
        });

        var json = await res.json();

        if (!res.ok || json.errors) {
            throw new Error('Storefront API error');
        }

        return json;
    }

    async function fetchTagsForBrand(brand) {
        if (!storefrontEndpoint || !storefrontToken || !brand) return [];

        var cacheKey = brand;
        if (tagCache[cacheKey]) return tagCache[cacheKey];
        if (tagCachePromises[cacheKey]) return tagCachePromises[cacheKey];

        tagCachePromises[cacheKey] = (async function () {
            var q = 'vendor:"' + brand.replace(/"/g, '\\"') + '"';
            var allTags = {};
            var after = null;
            var safety = 0;
            var maxPages = 50; // 50 x 250 = 12,500 products safety cap

            try {
                while (safety < maxPages) {
                    safety++;

                    var variables = { q: q };
                    if (after) variables.after = after;

                    var json = await storefrontRequest(PANELS_QUERY, variables);
                    var data = json.data && json.data.products;
                    if (!data) break;

                    var edges = data.edges || [];
                    for (var i = 0; i < edges.length; i++) {
                        var product = edges[i].node;
                        var panels = parsePanels(product.commonPanels ? product.commonPanels.value : '');

                        for (var p = 0; p < panels.length; p++) {
                            allTags[panels[p]] = true;
                        }
                    }

                    if (data.pageInfo && data.pageInfo.hasNextPage && data.pageInfo.endCursor) {
                        after = data.pageInfo.endCursor;
                    } else {
                        break;
                    }
                }
            } catch (e) {
                // silently fail
            }

            var sorted = Object.keys(allTags).sort(function (a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });

            tagCache[cacheKey] = sorted;
            delete tagCachePromises[cacheKey];

            return sorted;
        })();

        return tagCachePromises[cacheKey];
    }

    async function fetchProducts(brand, panelName) {
        if (!storefrontEndpoint || !storefrontToken) return [];

        var q = 'vendor:"' + brand.replace(/"/g, '\\"') + '"';
        var allProducts = [];
        var after = null;
        var safety = 0;
        var maxPages = 50; // 50 x 250 = 12,500 products safety cap

        while (safety < maxPages) {
            safety++;

            var variables = { q: q };
            if (after) variables.after = after;

            var json = await storefrontRequest(PRODUCTS_QUERY, variables);
            var data = json.data && json.data.products;
            if (!data) break;

            var edges = data.edges || [];
            for (var i = 0; i < edges.length; i++) {
                allProducts.push(edges[i].node);
            }

            if (data.pageInfo && data.pageInfo.hasNextPage && data.pageInfo.endCursor) {
                after = data.pageInfo.endCursor;
            } else {
                break;
            }
        }

        return allProducts;
    }

    // ---------------------------
    // Filtering & calculation
    // ---------------------------
    function parsePanels(metafieldValue) {
        return parseListMetafield(metafieldValue);
    }

    function parseCptCodes(metafieldValue) {
        if (!metafieldValue) return [];
        try {
            var parsed = JSON.parse(metafieldValue);
            if (Array.isArray(parsed)) {
                return parsed.map(function (s) { return String(s).trim(); }).filter(Boolean);
            }
            if (typeof parsed === 'string') return [parsed.trim()];
        } catch (e) {}
        return String(metafieldValue).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }

    function parseNumberOfTests(metafieldValue) {
        if (!metafieldValue) return 0;
        var n = parseFloat(String(metafieldValue).replace(/[^0-9.]/g, ''));
        return isNaN(n) || n <= 0 ? 0 : n;
    }

    function extractNumericId(gid) {
        // gid://shopify/ProductVariant/12345 → 12345
        var parts = String(gid || '').split('/');
        return parts[parts.length - 1] || '';
    }

    function filterAndCalculate(products, panelName, panelCount, productType, analyzers) {
        var results = [];
        var lowerPanel = String(panelName || '').trim().toLowerCase();
        var ptFilter = productType || 'all';

        for (var i = 0; i < products.length; i++) {
            var product = products[i];

            // 1. Filter by compatible analyzer (at least one analyzer must match)
            if (!matchesAnalyzer(product, analyzers)) continue;

            // 2. Filter by product type
            if (!matchesProductType(product, ptFilter)) continue;

            // 3. Panel must exist as one of product panels (trim + toLowerCase)
            var panels = parsePanels(product.commonPanels ? product.commonPanels.value : '');
            var hasPanel = panels.some(function (panel) {
                return String(panel).trim().toLowerCase() === lowerPanel;
            });

            if (!hasPanel) continue;

            var numTests = parseNumberOfTests(product.numberOfTests ? product.numberOfTests.value : '');
            var qty = numTests > 0 ? Math.ceil(panelCount / numTests) : 0;

            var variants = (product.variants && product.variants.edges) || [];
            for (var v = 0; v < variants.length; v++) {
                var variant = variants[v].node;
                if (!variant) continue;

                var price = parseFloat(variant.price ? variant.price.amount : '0') || 0;
                var cptCodes = parseCptCodes(product.cptCodes ? product.cptCodes.value : '');
                var rateMap = parseRateMetafield(product.rate ? product.rate.value : '', cptCodes);
                var costPerTest = numTests > 0 ? (price / numTests) : 0;

                results.push({
                    sku: variant.sku || '—',
                    title: product.title,
                    handle: product.handle,
                    variantId: extractNumericId(variant.id),
                    quantity: qty,
                    numberOfTests: numTests,
                    testName: product.testName ? product.testName.value : '',
                    cptCodes: cptCodes,
                    cptRateMap: rateMap,
                    price: price,
                    costPerTest: costPerTest
                });
            }
        }

        return results;
    }

    function parseDecimalNumber(value) {
        if (value === null || value === undefined || value === '') return 0;
        var n = parseFloat(String(value).replace(/[^0-9.\-]/g, ''));
        return isNaN(n) ? 0 : n;
    }

    function parseRateMetafield(value, cptCodes) {
        var codes = Array.isArray(cptCodes) ? cptCodes : [];
        var map = {};

        if (value === null || value === undefined || value === '') {
            return map;
        }

        var raw = String(value).trim();

        // JSON object: {"82962":3.28,"84200":0}
        try {
            var parsed = JSON.parse(raw);

            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                Object.keys(parsed).forEach(function (key) {
                    map[String(key).trim()] = parseDecimalNumber(parsed[key]);
                });
                return map;
            }

            // JSON array aligned with CPT codes: [3.28,0,6.89]
            if (Array.isArray(parsed)) {
                for (var i = 0; i < codes.length; i++) {
                    map[codes[i]] = parseDecimalNumber(parsed[i]);
                }
                return map;
            }
        } catch (e) {
            // not JSON
        }

        // Scalar fallback
        var scalar = parseDecimalNumber(raw);

        if (codes.length === 1) {
            map[codes[0]] = scalar;
        } else if (codes.length > 1) {
            map[codes[0]] = scalar;
            for (var j = 1; j < codes.length; j++) {
                map[codes[j]] = 0;
            }
        }

        return map;
    }

    function formatMoney(value) {
        return '$' + (Number(value) || 0).toFixed(2);
    }

    function formatPercent(value) {
        return (Number(value) || 0).toFixed(1) + '%';
    }

    // ---------------------------
    // Tag Autocomplete
    // ---------------------------
    var ac = {
        dropdown: null,
        inputEl: null,
        items: [],
        active: -1
    };

    function acRemove() {
        if (ac.dropdown) ac.dropdown.remove();
        ac.dropdown = null;
        ac.inputEl = null;
        ac.items = [];
        ac.active = -1;
    }

    function acEnsure() {
        if (ac.dropdown) return ac.dropdown;
        var el = document.createElement('div');
        el.className = 'qa-ac';
        document.body.appendChild(el);
        ac.dropdown = el;
        return el;
    }

    function acPosition() {
        if (!ac.dropdown || !ac.inputEl) return;
        var r = ac.inputEl.getBoundingClientRect();
        ac.dropdown.style.left = (window.scrollX + r.left) + 'px';
        ac.dropdown.style.top = (window.scrollY + r.bottom) + 'px';
        ac.dropdown.style.width = r.width + 'px';
    }

    function acRender() {
        if (!ac.items.length) return acRemove();

        acEnsure();
        ac.dropdown.innerHTML = '';

        ac.items.forEach(function (tag, i) {
            var el = document.createElement('div');
            el.className = 'qa-ac__item' + (i === ac.active ? ' is-active' : '');
            el.textContent = tag;

            el.addEventListener('mousedown', function (e) {
                e.preventDefault();
                panelNameInput.value = tag;
                acRemove();
            });

            ac.dropdown.appendChild(el);
        });

        acPosition();
    }

    var acSearch = debounce(async function () {
        if (!ac.inputEl) return;

        var term = (ac.inputEl.value || '').trim().toLowerCase();
        if (term.length < 2) return acRemove();

        var config = getSelectedConfig();
        if (!config) return acRemove();

        var tags = await fetchTagsForBrand(config.brand);

        var filtered = tags.filter(function (t) {
            return t.toLowerCase().indexOf(term) !== -1;
        }).slice(0, 10);

        ac.items = filtered;
        ac.active = filtered.length ? 0 : -1;
        acRender();
    }, 250);

    function initTagAutocomplete() {
        if (!panelNameInput) return;

        panelNameInput.setAttribute('autocomplete', 'off');

        panelNameInput.addEventListener('input', function () {
            ac.inputEl = panelNameInput;
            acSearch();
        });

        panelNameInput.addEventListener('focus', function () {
            ac.inputEl = panelNameInput;
            var config = getSelectedConfig();
            if (config) fetchTagsForBrand(config.brand);
        });

        panelNameInput.addEventListener('keydown', function (e) {
            if (!ac.dropdown || ac.inputEl !== panelNameInput) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                ac.active = Math.min(ac.active + 1, ac.items.length - 1);
                acRender();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                ac.active = Math.max(ac.active - 1, 0);
                acRender();
            } else if (e.key === 'Enter') {
                if (ac.items[ac.active]) {
                    e.preventDefault();
                    panelNameInput.value = ac.items[ac.active];
                    acRemove();
                }
            } else if (e.key === 'Escape') {
                e.preventDefault();
                acRemove();
            }
        });

        panelNameInput.addEventListener('blur', function () {
            setTimeout(function () {
                if (ac.inputEl === panelNameInput) acRemove();
            }, 120);
        });

        document.addEventListener('mousedown', function (e) {
            if (!ac.dropdown) return;
            if (ac.inputEl && e.target === ac.inputEl) return;
            if (ac.dropdown.contains(e.target)) return;
            acRemove();
        });

        window.addEventListener('resize', function () {
            if (ac.dropdown) acPosition();
        });

        document.addEventListener('scroll', function () {
            if (ac.dropdown) acPosition();
        }, true);

        var lastBrand = getSelectedConfig() ? getSelectedConfig().brand : '';
        var radios = document.querySelectorAll('input[name="sbp-brand"]');
        for (var i = 0; i < radios.length; i++) {
            radios[i].addEventListener('change', function () {
                var config = getSelectedConfig();
                var newBrand = config ? config.brand : '';
                acRemove();
                if (newBrand !== lastBrand) {
                    panelNameInput.value = '';
                    lastBrand = newBrand;
                    if (newBrand) fetchTagsForBrand(newBrand);
                }
            });
        }
    }

    // ---------------------------
    // Rendering
    // ---------------------------
    function updateEstimatedTotal() {
        var totalEl = document.getElementById('sbp-estimated-total');
        var revenuePerPanelEl = document.getElementById('sbp-revenue-per-panel');
        var revenuePer50El = document.getElementById('sbp-revenue-per-50');
        var cogsPerPanelEl = document.getElementById('sbp-cogs-per-panel');
        var cogsPer50El = document.getElementById('sbp-cogs-per-50');
        var grossProfitPerPanelEl = document.getElementById('sbp-gross-profit-per-panel');
        var grossProfitPer50El = document.getElementById('sbp-gross-profit-per-50');
        var grossMarginPerPanelEl = document.getElementById('sbp-gross-margin-per-panel');
        var grossMarginPer50El = document.getElementById('sbp-gross-margin-per-50');
        var dynamicPanelCountEl = document.getElementById('sbp-dynamic-panel-count');

        if (!totalEl) return;

        var rows = resultsBody.querySelectorAll('tr');

        var grandTotal = 0;
        var cogsPerPanel = 0;
        var revenuePerPanel = 0;
        var seenCptCodes = {};

        rows.forEach(function (row) {
            var input = row.querySelector('.panel-qty');
            if (!input) return;

            var unitPrice = parseFloat(input.dataset.unitPrice) || 0;
            var qty = parseInt(input.value, 10) || 0;
            var costPerTest = parseFloat(input.dataset.costPerTest) || 0;

            grandTotal += unitPrice * qty;
            cogsPerPanel += costPerTest;

            var cptCodes = [];
            var cptRateMap = {};

            try {
                cptCodes = JSON.parse(input.dataset.cptCodes || '[]');
            } catch (e) {
                cptCodes = [];
            }

            try {
                cptRateMap = JSON.parse(input.dataset.cptRateMap || '{}');
            } catch (e) {
                cptRateMap = {};
            }

            for (var i = 0; i < cptCodes.length; i++) {
                var code = String(cptCodes[i] || '').trim();
                if (!code) continue;
                if (seenCptCodes[code]) continue;

                seenCptCodes[code] = true;
                revenuePerPanel += parseDecimalNumber(cptRateMap[code]);
            }
        });

        var selectedPanelCount = parseInt(panelCountInput.value, 10) || 0;

        if (dynamicPanelCountEl) {
            dynamicPanelCountEl.textContent = selectedPanelCount > 0 ? selectedPanelCount : 0;
        }

        var revenuePerTotalPanels = revenuePerPanel * selectedPanelCount;
        var cogsPerTotalPanels = cogsPerPanel * selectedPanelCount;
        var grossProfitPerPanel = revenuePerPanel - cogsPerPanel;
        var grossProfitPerTotalPanels = revenuePerTotalPanels - cogsPerTotalPanels;
        var grossMarginPercent = revenuePerPanel > 0 ? ((grossProfitPerPanel / revenuePerPanel) * 100) : 0;

        totalEl.textContent = formatMoney(grandTotal);

        if (revenuePerPanelEl) revenuePerPanelEl.textContent = formatMoney(revenuePerPanel);
        if (revenuePer50El) revenuePer50El.textContent = formatMoney(revenuePerTotalPanels);

        if (cogsPerPanelEl) cogsPerPanelEl.textContent = formatMoney(cogsPerPanel);
        if (cogsPer50El) cogsPer50El.textContent = formatMoney(cogsPerTotalPanels);

        if (grossProfitPerPanelEl) grossProfitPerPanelEl.textContent = formatMoney(grossProfitPerPanel);
        if (grossProfitPer50El) grossProfitPer50El.textContent = formatMoney(grossProfitPerTotalPanels);

        if (grossMarginPerPanelEl) grossMarginPerPanelEl.textContent = formatPercent(grossMarginPercent);
        if (grossMarginPer50El) grossMarginPer50El.textContent = formatPercent(grossMarginPercent);
    }

    function updateResultsStatus() {
        var rowCount = resultsBody.querySelectorAll('tr').length;
        if (rowCount === 0) {
            resultsCard.style.display = 'none';
            statusEl.textContent = 'All items removed.';
        } else {
            statusEl.textContent = rowCount + ' product(s) found.';
        }
        updateEstimatedTotal();
    }

    function renderResults(results) {
        resultsBody.innerHTML = '';

        if (!results.length) {
            resultsCard.style.display = 'none';
            statusEl.textContent = 'No matching products found for this panel.';
            updateEstimatedTotal();
            return;
        }

        for (var i = 0; i < results.length; i++) {
            var r = results[i];
            var tr = document.createElement('tr');

            var tdSku = document.createElement('td');
            tdSku.className = 'sbp-desktop-only';
            tdSku.textContent = r.sku;

            var tdTitle = document.createElement('td');

            var mSku = document.createElement('div');
            mSku.className = 'sbp-mobile-only sbp-mobile-sku';
            mSku.textContent = r.sku;
            tdTitle.appendChild(mSku);

            var link = document.createElement('a');
            link.href = '/products/' + r.handle;
            link.textContent = r.title;
            link.target = '_blank';
            link.rel = 'noopener';
            tdTitle.appendChild(link);

            if (r.testName) {
                var testNameInfo = document.createElement('div');
                testNameInfo.className = 'sbp-test-name';
                testNameInfo.textContent = 'Test name: ' + r.testName;
                tdTitle.appendChild(testNameInfo);
            }

            if (r.numberOfTests > 0) {
                var testsInfo = document.createElement('div');
                testsInfo.className = 'sbp-num-tests';
                testsInfo.textContent = 'Number of tests: ' + r.numberOfTests;
                tdTitle.appendChild(testsInfo);
            }

            var cptText = r.cptCodes.length ? r.cptCodes.join(', ') : '';
            if (cptText) {
                var mCpt = document.createElement('div');
                mCpt.className = 'sbp-mobile-only sbp-mobile-detail';
                mCpt.textContent = 'CPT: ' + cptText;
                tdTitle.appendChild(mCpt);
            }

            if (r.price > 0) {
                var mPrice = document.createElement('div');
                mPrice.className = 'sbp-mobile-only sbp-mobile-detail';
                mPrice.textContent = 'Price: $' + r.price.toFixed(2);
                tdTitle.appendChild(mPrice);
            }

            var tdCpt = document.createElement('td');
            tdCpt.className = 'sbp-desktop-only';
            tdCpt.textContent = r.cptCodes.length ? r.cptCodes.join(', ') : '—';

            var tdPrice = document.createElement('td');
            tdPrice.className = 'sbp-desktop-only';
            tdPrice.textContent = r.price > 0 ? '$' + r.price.toFixed(2) : '—';

            var tdQty = document.createElement('td');
            var input = document.createElement('input');
            input.type = 'number';
            input.min = '1';
            input.value = r.quantity > 0 ? r.quantity : 1;
            input.className = 'sbp-input panel-qty';

            input.dataset.variantId = r.variantId;
            input.dataset.unitPrice = r.price;
            input.dataset.costPerTest = r.costPerTest;
            input.dataset.cptCodes = JSON.stringify(r.cptCodes || []);
            input.dataset.cptRateMap = JSON.stringify(r.cptRateMap || {});
            tdQty.appendChild(input);

            var tdTotal = document.createElement('td');
            tdTotal.className = 'sbp-row-total';
            var rowTotal = r.price * (r.quantity > 0 ? r.quantity : 1);
            tdTotal.textContent = rowTotal > 0 ? '$' + rowTotal.toFixed(2) : '—';

            (function (inputEl, totalEl, unitPrice) {
                inputEl.addEventListener('input', function () {
                    var qty = parseInt(inputEl.value, 10) || 0;
                    totalEl.textContent = unitPrice > 0 && qty > 0 ? '$' + (unitPrice * qty).toFixed(2) : '—';
                    updateEstimatedTotal();
                });
            })(input, tdTotal, r.price);

            var tdRemove = document.createElement('td');
            tdRemove.className = 'sbp-td-remove';
            var removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'sbp-remove-btn';
            removeBtn.textContent = '\u00d7';
            removeBtn.setAttribute('aria-label', 'Remove row');

            (function (rowEl) {
                removeBtn.addEventListener('click', function () {
                    rowEl.remove();
                    updateResultsStatus();
                });
            })(tr);

            tdRemove.appendChild(removeBtn);

            tr.appendChild(tdSku);
            tr.appendChild(tdTitle);
            tr.appendChild(tdCpt);
            tr.appendChild(tdPrice);
            tr.appendChild(tdQty);
            tr.appendChild(tdTotal);
            tr.appendChild(tdRemove);
            resultsBody.appendChild(tr);
        }

        resultsCard.style.display = '';
        statusEl.textContent = results.length + ' product(s) found.';
        cartStatusEl.textContent = '';
        updateEstimatedTotal();

        if (resultsCard) resultsCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // ---------------------------
    // Add to Cart
    // ---------------------------
    async function addAllToCart() {
        var items = Array.from(document.querySelectorAll('.panel-qty'))
            .map(function (input) {
                return {
                    id: Number(input.dataset.variantId),
                    quantity: Number(input.value) || 1
                };
            })
            .filter(function (item) {
                return item.id && item.quantity > 0;
            });

        if (!items.length) {
            cartStatusEl.textContent = 'No items to add (quantity is zero or missing variant).';
            return;
        }

        addToCartBtn.disabled = true;
        cartStatusEl.textContent = 'Adding to cart…';

        try {
            var res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ items: items })
            });

            if (!res.ok) {
                var err = await res.json().catch(function () { return {}; });
                cartStatusEl.textContent = 'Error: ' + (err.description || err.message || 'Could not add to cart.');
                return;
            }

            cartStatusEl.textContent = items.length + ' product(s) added to cart.';

            fetch('/?section_id=cart-icon-bubble')
                .then(function (r) { return r.text(); })
                .then(function (html) {
                    var bubble = document.getElementById('cart-icon-bubble');
                    if (bubble) {
                        var doc = new DOMParser().parseFromString(html, 'text/html');
                        var newBubble = doc.querySelector('.shopify-section');
                        if (newBubble) bubble.innerHTML = newBubble.innerHTML;
                    }
                });
        } catch (e) {
            cartStatusEl.textContent = 'Network error. Please try again.';
        } finally {
            addToCartBtn.disabled = false;
        }
    }

    // ---------------------------
    // Search handler
    // ---------------------------
    async function handleSearch() {
        var config = getSelectedConfig();
        var panelName = (panelNameInput.value || '').trim();
        var panelCount = parseInt(panelCountInput.value, 10);

        if (!config) { statusEl.textContent = 'Please select a brand.'; return; }
        if (!panelName) { statusEl.textContent = 'Please enter a panel name.'; return; }
        if (!panelCount || panelCount < 1) { statusEl.textContent = 'Please enter a valid number of panels.'; return; }

        searchBtn.disabled = true;
        statusEl.textContent = 'Searching…';
        resultsCard.style.display = 'none';
        currentResults = [];

        var productType = getSelectedProductType();

        try {
            var products = await fetchProducts(config.brand, panelName);
            currentResults = filterAndCalculate(products, panelName, panelCount, productType, getMatchAnalyzers(config));
            renderResults(currentResults);
        } catch (e) {
            statusEl.textContent = 'Error fetching products. Please try again.';
        } finally {
            searchBtn.disabled = false;
        }
    }

    // ---------------------------
    // Brand tooltips (included analyzers): hover tooltip on desktop, hint line on touch devices
    // ---------------------------
    function initBrandTooltips() {
        var hintEl = document.getElementById('sbp-brand-hint');
        var radios = document.querySelectorAll('input[name="sbp-brand"]');

        for (var i = 0; i < radios.length; i++) {
            var config = BRAND_CONFIG[radios[i].value];
            var label = radios[i].closest('.sbp-radio-label');
            if (!config || !label) continue;

            var tooltip = document.createElement('span');
            tooltip.className = 'sbp-radio-tooltip';
            tooltip.textContent = getAnalyzersLabel(config);
            label.appendChild(tooltip);

            radios[i].addEventListener('change', updateHint);
        }

        function updateHint() {
            var config = getSelectedConfig();
            if (hintEl) hintEl.textContent = config ? getAnalyzersLabel(config) : '';
        }

        updateHint();
    }

    // ---------------------------
    // Init
    // ---------------------------
    function init() {
        searchBtn = document.getElementById('sbp-search-btn');
        panelNameInput = document.getElementById('sbp-panel-name');
        panelCountInput = document.getElementById('sbp-panel-count');
        resultsCard = document.getElementById('sbp-results-card');
        resultsBody = document.getElementById('sbp-results-body');
        addToCartBtn = document.getElementById('sbp-add-to-cart-btn');
        statusEl = document.getElementById('sbp-status');
        cartStatusEl = document.getElementById('sbp-cart-status');

        if (!searchBtn) return;

        shopDomain = (window.__SHOP_DOMAIN__ || getMeta('shop-domain') || window.location.hostname || '').trim();
        storefrontToken = (window.__SF_API_TOKEN__ || getMeta('storefront-api-token') || '').trim();
        apiVersion = (window.__SF_API_VERSION__ || getMeta('storefront-api-version') || '2025-10').trim();
        storefrontEndpoint = buildStorefrontEndpoint();

        searchBtn.addEventListener('click', handleSearch);
        addToCartBtn.addEventListener('click', addAllToCart);

        initTagAutocomplete();
        initBrandTooltips();
    }

    function renderDebugInfo() {
        var cptSummaryEl = document.getElementById('sbp-debug-cpt-summary');
        var productsBodyEl = document.getElementById('sbp-debug-products-body');

        if (!cptSummaryEl || !productsBodyEl) return;

        var rows = resultsBody.querySelectorAll('tr');
        var seenCptCodes = {};
        var cptLines = [];

        productsBodyEl.innerHTML = '';

        rows.forEach(function (row) {
            var input = row.querySelector('.panel-qty');
            if (!input) return;

            var qty = parseInt(input.value, 10) || 0;
            var unitPrice = parseFloat(input.dataset.unitPrice) || 0;

            var sku = '';
            var productName = '';

            var skuCell = row.querySelector('td.sbp-desktop-only');
            if (skuCell) {
                sku = (skuCell.textContent || '').trim();
            }

            var productLink = row.querySelector('td a');
            if (productLink) {
                productName = (productLink.textContent || '').trim();
            }

            var testsPerKit = '';
            var testsInfo = row.querySelector('.sbp-num-tests');
            if (testsInfo) {
                testsPerKit = (testsInfo.textContent || '').replace('Number of tests:', '').trim();
            }

            var cptCodes = [];
            var cptRateMap = {};

            try {
                cptCodes = JSON.parse(input.dataset.cptCodes || '[]');
            } catch (e) {
                cptCodes = [];
            }

            try {
                cptRateMap = JSON.parse(input.dataset.cptRateMap || '{}');
            } catch (e) {
                cptRateMap = {};
            }

            for (var i = 0; i < cptCodes.length; i++) {
                var code = String(cptCodes[i] || '').trim();
                if (!code) continue;

                if (!seenCptCodes[code]) {
                    seenCptCodes[code] = parseDecimalNumber(cptRateMap[code]);
                }
            }

            var tr = document.createElement('tr');

            function td(text) {
                var el = document.createElement('td');
                el.textContent = text;
                return el;
            }

            tr.appendChild(td(sku || '—'));
            tr.appendChild(td(productName || '—'));
            tr.appendChild(td(cptCodes.join(', ') || '—'));
            tr.appendChild(td(JSON.stringify(cptRateMap)));
            tr.appendChild(td(formatMoney(unitPrice)));
            tr.appendChild(td(testsPerKit || '—'));
            tr.appendChild(td(formatMoney(parseFloat(input.dataset.costPerTest) || 0)));
            tr.appendChild(td(String(qty)));
            tr.appendChild(td(formatMoney(unitPrice * qty)));

            productsBodyEl.appendChild(tr);
        });

        var codes = Object.keys(seenCptCodes).sort();

        if (!codes.length) {
            cptSummaryEl.innerHTML = '<p>No CPT codes used.</p>';
            return;
        }

        for (var j = 0; j < codes.length; j++) {
            var code = codes[j];
            cptLines.push(
                '<div><strong>' + code + '</strong>: ' + formatMoney(seenCptCodes[code]) + '</div>'
            );
        }

        var totalRevenue = 0;
        codes.forEach(function (code) {
            totalRevenue += parseDecimalNumber(seenCptCodes[code]);
        });

        cptLines.push('<hr style="margin:8px 0;">');
        cptLines.push('<div><strong>Total Revenue / Panel:</strong> ' + formatMoney(totalRevenue) + '</div>');

        cptSummaryEl.innerHTML = cptLines.join('');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();